<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title has-text-centered">
        {{ $t("totemJourneys.modalTitle") }}
      </p>
    </header>

    <section class="modal-card-body">
      <div class="columns">
        <div class="column">
          <p>
            <b>{{ $t("totemJourneys.store") }}: </b
            >{{ journey.storeName || journey.storeId || "-" }}
          </p>
          <p>
            <b>{{ $t("totemJourneys.totem") }}: </b
            >{{ journey.deviceId || "-" }}
            <small v-if="journey.totem">
              ({{ journey.totem.manufacturer }} {{ journey.totem.model }})
            </small>
          </p>
          <p>
            <b>{{ $t("totemJourneys.result") }}: </b>
            <b-tag :type="resultTag.type">{{ resultTag.label }}</b-tag>
          </p>
        </div>

        <div class="column">
          <p>
            <b>{{ $t("totemJourneys.start") }}: </b
            >{{ formatDate(journey.startedAt) }}
          </p>
          <p>
            <b>{{ $t("totemJourneys.end") }}: </b
            >{{ formatDate(journey.endedAt) }}
          </p>
          <p>
            <b>{{ $t("totemJourneys.duration") }}: </b>{{ duration }}
          </p>
        </div>
      </div>

      <p
        style="cursor: pointer"
        @click="
          copyContent(journey.journeyId, $t('totemJourneys.journeyIdCopied'))
        "
      >
        <small
          >{{ $t("totemJourneys.journeyId") }}: {{ journey.journeyId }}</small
        >
        <b-icon icon="copy" size="is-small"></b-icon>
      </p>

      <p
        v-for="transactionId in journey.transactionIds || []"
        :key="transactionId"
        style="cursor: pointer"
        @click="
          copyContent(transactionId, $t('totemJourneys.transactionIdCopied'))
        "
      >
        <small>
          {{ $t("totemJourneys.transactionId") }}: {{ transactionId }}
        </small>
        <b-icon icon="copy" size="is-small"></b-icon>
      </p>

      <br />

      <b-table :data="events" narrowed striped>
        <b-table-column field="sequence" label="#" v-slot="props" numeric>
          {{ props.row.sequence }}
        </b-table-column>

        <b-table-column
          field="timestamp"
          :label="$t('totemJourneys.time')"
          v-slot="props"
        >
          {{ formatTime(props.row.timestamp) }}
        </b-table-column>

        <b-table-column
          field="screen"
          :label="$t('totemJourneys.screen')"
          v-slot="props"
        >
          {{ props.row.screen }}
        </b-table-column>

        <b-table-column
          field="label"
          :label="$t('totemJourneys.action')"
          v-slot="props"
        >
          {{ props.row.label }}
          <br />
          <small class="has-text-grey">{{ props.row.eventType }}</small>
        </b-table-column>

        <b-table-column
          field="actionType"
          :label="$t('totemJourneys.type')"
          v-slot="props"
        >
          <b-tag
            :type="props.row.actionType === 'manual' ? 'is-info' : 'is-light'"
          >
            {{
              props.row.actionType === "manual"
                ? $t("totemJourneys.manual")
                : $t("totemJourneys.automatic")
            }}
          </b-tag>
        </b-table-column>

        <b-table-column :label="$t('totemJourneys.details')" v-slot="props">
          <p
            v-for="entry in metadataEntries(props.row.metadata)"
            :key="entry.key"
          >
            <small>
              <b>{{ entry.key }}:</b> {{ entry.value }}
            </small>
          </p>
        </b-table-column>

        <template slot="empty">
          <table-empty-template />
        </template>
      </b-table>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import tableEmptyTemplate from "../common/TableEmptyTemplate";

const RESULT_TAGS = {
  sucesso: { label: "totemJourneys.resultSuccess", type: "is-success" },
  abandonada: { label: "totemJourneys.resultAbandoned", type: "is-warning" },
  cancelada_manual: {
    label: "totemJourneys.resultCancelledByClient",
    type: "is-danger"
  }
};

export default {
  props: ["journey", "events"],

  mixins: [common],

  components: {
    tableEmptyTemplate
  },

  methods: {
    formatDate(date) {
      return date
        ? this.moment
            .utc(date)
            .add(this.preferences.timezone, "h")
            .format("DD/MM/YY HH:mm:ss")
        : "-";
    },

    formatTime(date) {
      return this.moment
        .utc(date)
        .add(this.preferences.timezone, "h")
        .format("HH:mm:ss");
    },

    metadataEntries(metadata) {
      return Object.keys(metadata || {})
        .filter(key => metadata[key] !== "" && metadata[key] !== null)
        .map(key => ({ key, value: metadata[key] }));
    }
  },

  computed: {
    ...mapGetters(["preferences"]),

    resultTag() {
      const tag = RESULT_TAGS[this.journey.result];

      return tag
        ? { label: this.$t(tag.label), type: tag.type }
        : { label: this.journey.result || "-", type: "is-light" };
    },

    duration() {
      if (!this.journey.startedAt || !this.journey.endedAt) return "-";

      const seconds = Math.round(
        (new Date(this.journey.endedAt) - new Date(this.journey.startedAt)) /
          1000
      );

      return `${Math.floor(seconds / 60)}min ${seconds % 60}s`;
    }
  }
};
</script>
